import { useEffect, useRef, useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';

export type UseSearchBarProps = {
  searchValue: string;
  onSearchValueChanged: (value: string) => void;
  changeLocalValueFunc?: (changeLocalValue: () => void) => void;
};

const useSearchBar = ({
  searchValue,
  onSearchValueChanged,
  changeLocalValueFunc,
}: UseSearchBarProps): {
  localSearchValue: string;
  changeLocalValue: (newValue: string) => void;
  setLocalSearchValue: React.Dispatch<React.SetStateAction<string>>;
} => {
  const [localSearchValue, setLocalSearchValue] = useState(searchValue);
  const [debouncedValue] = useDebounceValue<string>(localSearchValue, 300);
  const firstUpdate = useRef(true);

  useEffect(() => {
    setLocalSearchValue(searchValue);
  }, [searchValue]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    onSearchValueChanged(localSearchValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  const changeLocalValue = (newValue: string): void => {
    if (changeLocalValueFunc) {
      changeLocalValueFunc(() => setLocalSearchValue(newValue));
    } else {
      setLocalSearchValue(newValue);
    }
  };

  return {
    localSearchValue,
    changeLocalValue,
    setLocalSearchValue,
  };
};

export default useSearchBar;
